module.exports = __webpack_public_path__ + "github.png";